$(document).ready(function () {
    $('input[name="phone"]').inputmask({'mask': '+1 353 99 9999999'}); 
});